import { render, staticRenderFns } from "./ChooseLesson.vue?vue&type=template&id=0a577e2b&scoped=true&"
import script from "./ChooseLesson.vue?vue&type=script&lang=js&"
export * from "./ChooseLesson.vue?vue&type=script&lang=js&"
import style0 from "./ChooseLesson.vue?vue&type=style&index=0&id=0a577e2b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a577e2b",
  null
  
)

export default component.exports